<script lang="ts">
	import { onMount } from 'svelte';
	import Download from '@lucide/svelte/icons/download';
	import X from '@lucide/svelte/icons/x';

	interface BeforeInstallPromptEvent extends Event {
		prompt: () => Promise<void>;
		userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
	}

	let prompt = $state<BeforeInstallPromptEvent | null>(null);
	let dismissed = $state(false);

	onMount(() => {
		if (typeof window === 'undefined') return;
		if (localStorage.getItem('sayano:install-dismissed') === '1') {
			dismissed = true;
			return;
		}
		const handler = (e: Event) => {
			e.preventDefault();
			prompt = e as BeforeInstallPromptEvent;
		};
		const installedHandler = () => {
			prompt = null;
			localStorage.setItem('sayano:install-dismissed', '1');
		};
		window.addEventListener('beforeinstallprompt', handler);
		window.addEventListener('appinstalled', installedHandler);
		return () => {
			window.removeEventListener('beforeinstallprompt', handler);
			window.removeEventListener('appinstalled', installedHandler);
		};
	});

	async function install() {
		if (!prompt) return;
		prompt.prompt();
		await prompt.userChoice;
		prompt = null;
	}

	function dismiss() {
		dismissed = true;
		localStorage.setItem('sayano:install-dismissed', '1');
	}
</script>

{#if prompt && !dismissed}
	<div class="flex items-center gap-2 rounded-md border border-border bg-card px-2.5 py-1.5 text-xs">
		<button
			type="button"
			onclick={install}
			class="flex items-center gap-1.5 font-medium text-foreground"
		>
			<Download class="size-3.5" />
			Install app
		</button>
		<button
			type="button"
			onclick={dismiss}
			class="ml-auto -mr-1 rounded p-1 text-muted-foreground hover:text-foreground"
			aria-label="Dismiss install prompt"
		>
			<X class="size-3" />
		</button>
	</div>
{/if}
